import { Component, OnInit, ElementRef, ViewChild, Inject, TemplateRef, HostListener } from '@angular/core';
import * as Chartist from 'chartist';

import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { interval } from 'rxjs';

import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { formatDate } from "@angular/common";

import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ReponseWebService } from '../datastruct/Meloyi.module';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { ServicepoolService } from '../services/servicepool.service';
import { MatTableDataSource } from '@angular/material/table';
import { DetailDSashboardComponent } from '../detail-dsashboard/detail-dsashboard.component';

import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MatProgressBarModule } from '@angular/material/progress-bar';

import { DetailsclientcrmComponent } from '../detailsclientcrm/detailsclientcrm.component';

import { GestockService } from '../services/gestock.service';

import { MatSnackBar } from '@angular/material/snack-bar';


import { ModificationgeneraleComponent } from '../modificationgenerale/modificationgenerale.component';


const source = interval(120000);

const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  )
};

const httpOptionsII = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  )
};



@Component({
  selector: 'app-crm',
  templateUrl: './crm.component.html',
  styleUrls: ['./crm.component.css']
})
export class CrmComponent implements OnInit {


  maxHeight = 150; // Hauteur initiale
  minHeight = 60; // Hauteur minimale
  headerHeight: any;

  boutiques: any; //string[] = ['Toutes', 'Boutique A', 'Boutique B'];
  selectedBoutique: string = 'Toutes';

  dateRange = {
    start: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    end: new Date()
  };

  stockRotation: any;
  dormantProducts = 0;
  stockValue = 0;
  availabilityRate = 0;


  clientsAlertes = [
    { nom: 'Modou Seck', pourcentage: 0 },
    { nom: 'Ablaye Sylla', pourcentage: 20 },
    { nom: 'André Diakhoumpa', pourcentage: 60 },
    { nom: 'Mor Tine', pourcentage: 100 },
  ];

  clients: any;

  clientsStats: any;/* = [
  {
    nom: 'Modou Seck',
    dernierAchat: new Date('2025-04-15'),
    moyenne10j: 120,
    panierMoyen: 40,
    caPeriodique: 360,
    benefice: 90
  },
  {
    nom: 'Ablaye Sylla',
    dernierAchat: new Date('2025-04-20'),
    moyenne10j: 200,
    panierMoyen: 50,
    caPeriodique: 400,
    benefice: 130
  },
  {
    nom: 'André Diakhoumpa',
    dernierAchat: new Date('2025-02-02'),
    moyenne10j: 200,
    panierMoyen: 50,
    caPeriodique: 400,
    benefice: 100
  },
  {
    nom: 'Mor Tine',
    dernierAchat: new Date('2025-03-10'),
    moyenne10j: 300,
    panierMoyen: 250,
    caPeriodique: 400,
    benefice: 170
  },
];
*/

  handleError: any;
  commands: any[];
  commandsLastWeek: any[];
  commandsCurrentWeek: any[];
  nbreCmds = 0;
  revenus = 0;
  panierMoyen = 0;
  totalLivraison = 0;
  subscription: any;

  longTotal = 0;
  redLine = 0;
  OrangeLine = 0;
  blueLine = 0;
  greenLine = 0;


  chercheEcheance = false;

  nvllesCmds = 0;
  preparing = 0;
  enlivraison = 0;
  livrees = 0;

  ourFirstday: any;
  firstDayOfLastWeek: any;
  lastDayOfLastWeek: any;

  firstDayOfMonth: any;

  today = new Date();

  dataSource: MatTableDataSource<any>;
  dataSourceProspect: MatTableDataSource<any>;
  weekday = [];

  avenantsYeup: any;

  @ViewChild('myDiv') myDiv: ElementRef;

  block = 'client';

  // commands = [] ;

  allDetailedTransacts: any;

  datedeb: any;
  datefin: any;

  leClient: any;

  leClientpreexist = false;

  commissions = "-";
  plafondDispo: any;;
  localcompliances: any;

  tousmesclients = [];

  bruteFromServer = [];

  displayedColumns: string[] = ['nomboutique', 'clientFullName', 'nombre_commandes', 'total_achats', 'total_marge', 'derniere_commande', 'option'];
  displayedColumnsprospect: string[] = ['prenom', 'nom', 'telephone', 'statutrelance', 'etat', 'option'];
  // dataSource : any ;


  userchoice = 1;

  samacaabiyoonwii = "";
  porteeUser: any = "";


  choosenReport = 'Historique Conversion Manuelles';

  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('khaadiouKawbi') khaadiouKawbi!: ElementRef;

  spinnerDialogRef: any;

  retourClientWS: ReponseWebService;

  theCurrentBlock = "";
  nbreClients = 0;
  nbreProspects = 0;


  constructor(private httpClient: HttpClient, public dialog: MatDialog, private configServer: ServicepoolService,
    private clientGestockServices: GestockService, private snackBar: MatSnackBar, private _adapter: DateAdapter<any>, @Inject(MAT_DATE_LOCALE) private _locale: string) {
    /*this.datedeb = new Date(); 
    this.datefin = new Date();*/

  }

  ngOnInit() {
    this.samacaabiyoonwii = /*"3e179632fcc2066228f9a7e54c0a97e080d9514ef" ;*/ sessionStorage.getItem("samacaabiyoonwii");
    let profil = sessionStorage.getItem("profil");
    this.localcompliances = JSON.parse(sessionStorage.getItem("compliances"));
    this.porteeUser = sessionStorage.getItem("portee");
    this.getAllPoints();
  }


  getAllPoints() {

    this.clientGestockServices.getAllPoints(this.samacaabiyoonwii).then((retourbi) => {
      this.retourClientWS = retourbi;
      var statutreq = this.retourClientWS.statutreq;
      if (statutreq == 1) {
        console.log("Done");
        this.boutiques = this.retourClientWS.data;
        if (this.boutiques.length == 1)
          this.selectedBoutique = this.boutiques[0].idPoint;
        this.loadDashboardData();
      }
      else {
        console.log("Failed");
      }
    });
  }

  onBoutiqueChange(): void {
    this.loadDashboardData();
  }


  openModificationDialog(element: any): void {
    console.log(element);

    const dialogRef = this.dialog.open(ModificationgeneraleComponent, {
      width: '500px',
      data: {
        dataIntrinsect: { ...element, telephone: "" },
        changeables: ["clientFullName", "telephone"],
        cleChangement: "clients-id",
        lanelaniouySoppiLou: "Client",
        liniouySoppi: ["fullName", "phone"]
      } // on passe une copie de l'objet
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadDashboardData();
        console.log('Nouvelles valeurs:', result);
      }
    });
  }


  loadDashboardData(): void {
    if (!this.dateRange.start || !this.dateRange.end) return;

    let date_debut = this.dateRange.start.toISOString().split('T')[0];
    let date_fin = this.dateRange.end.toISOString().split('T')[0];

    this.clientGestockServices.getClientAndStats(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin).then((res) => {
      console.log(res);
      if (res.statutreq === 1) {
        this.clientsStats = res.data;
        this.getallclients();
      } else {
        console.warn('Erreur serveur:', res.message);
      }
    });

  }



  getallclients(): void {

    this.clientGestockServices.getallclients(this.samacaabiyoonwii, this.selectedBoutique).then((res) => {
      console.log("Tous les CLients: ", res);
      if (res.statutreq === 1) {
        this.clients = res.data;
        this.fullfillClientsList();
      } else {
        console.warn('Erreur serveur:', res.message);
      }
    });

  }


  fullfillClientsList() {

    for (var i = 0; i < this.clients.length; i++) {

      const existe = this.clientsStats.some(client => client.id === this.clients[i].id);

      let basicObjt = {
        "nomboutique": "",
        "id": 0,
        "clientFullName": "",
        "total_achats": 0,
        "total_articles": 0,
        "total_marge": 0,
        "nombre_commandes": 0,
        "derniere_commande": "",
        "moyenne_achat": 0
      };

      if (existe == false) {
        let elt = basicObjt;
        elt.clientFullName = this.clients[i].fullName;
        elt.nomboutique = this.clients[i].nompoint;
        this.clientsStats.push(elt);
      }

    }

    this.dataSource = new MatTableDataSource(this.clientsStats);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

  }



  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollY = window.scrollY;
    this.headerHeight = Math.max(this.maxHeight - scrollY, this.minHeight);
  }


  showSuccessSnackBar(message: string) {
    this.snackBar.open(message, 'Fermer', {
      duration: 600,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['custom-snackbar']
    });
  }


  retrieveInfoFromCustomerInfo(event) {
    if (event != undefined) {
      console.log(event);
      this.leClient = event;
      if (this.leClient.id == undefined)
        this.creerclient();
      else {
        this.leClientpreexist = true;
      }
    }
  }


  creerclient() {
    this.openSpinnerDialog();
    this.clientGestockServices.creerclient(this.samacaabiyoonwii, this.leClient).then((retourbi) => {
      this.closeSpinnerDialog();
      this.retourClientWS = retourbi;
      console.log(this.retourClientWS);

      var statutreq = this.retourClientWS.statutreq;
      if (statutreq == 1) {
        this.showSuccessSnackBar("Client enregistré avec succés");
        this.leClient = undefined;
      }
      else {
        this.showSuccessSnackBar("Echec de l'enregistrement du client");
        this.leClient = undefined;
      }
    });
  }



  startAnimationForLineChart(chart) {
    let seq: any, delays: any, durations: any;
    seq = 0;
    delays = 80;
    durations = 500;

    chart.on('draw', function (data) {
      if (data.type === 'line' || data.type === 'area') {
        data.element.animate({
          d: {
            begin: 600,
            dur: 700,
            from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
            to: data.path.clone().stringify(),
            easing: Chartist.Svg.Easing.easeOutQuint
          }
        });
      } else if (data.type === 'point') {
        seq++;
        data.element.animate({
          opacity: {
            begin: seq * delays,
            dur: durations,
            from: 0,
            to: 1,
            easing: 'ease'
          }
        });
      }
    });

    seq = 0;
  };
  startAnimationForBarChart(chart) {
    let seq2: any, delays2: any, durations2: any;

    seq2 = 0;
    delays2 = 80;
    durations2 = 500;
    chart.on('draw', function (data) {
      if (data.type === 'bar') {
        seq2++;
        data.element.animate({
          opacity: {
            begin: seq2 * delays2,
            dur: durations2,
            from: 0,
            to: 1,
            easing: 'ease'
          }
        });
      }
    });

    seq2 = 0;
  };

  openDialogDetailOp(elt): void {
    let passedValues = { 'element': elt, 'avenantsYeup': this.avenantsYeup };

    const dialogRef = this.dialog.open(DetailDSashboardComponent, {
      data: passedValues, disableClose: false, width: '100%'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }


  getMontantFormatee(montant) {
    let resultd = Number(montant).toLocaleString('fr-FR');
    return resultd;
  }


  openDialogUpdateClient(elt): void {
    let tamponEltBi = elt;
    let passedValues = { 'details': undefined, 'leClient': elt };
    const dialogRef = this.dialog.open(DetailsclientcrmComponent, {
      data: passedValues, disableClose: true, width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }


  getAllTransactsByDateInterval() {

    var debut = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');
    var fin = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');

    this.configServer.getReportingDashbord(this.samacaabiyoonwii, debut, fin).then((retourbi) => {
      // console.log(retourbi);
      this.retourClientWS = retourbi;
      console.log("Done");
      this.allDetailedTransacts = this.retourClientWS.data;
      console.log(this.allDetailedTransacts);

      this.nbreCmds = this.allDetailedTransacts.length;
      this.revenus = this.totalCmds(this.allDetailedTransacts);

      this.dataSource = new MatTableDataSource(this.allDetailedTransacts);
      //setTimeout(()=>{
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      //},1000)

      this.getBigChiffres();

    });
  }

  getSamayClients() {
    this.theCurrentBlock = "";
    /*var debut = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');
    var fin = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');*/

    //this.openSpinnerDialog();

    this.configServer.getSamayClients(this.samacaabiyoonwii, "debut", "fin").then((retourbi) => {

      //this.closeSpinnerDialog() ;

      console.log(retourbi);
      this.retourClientWS = retourbi;
      this.bruteFromServer = this.retourClientWS.data;
      this.tousmesclients = this.getLatestExpirations(this.retourClientWS.data);
      this.nbreClients = this.tousmesclients.length;

      this.dataSource = new MatTableDataSource(this.tousmesclients);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }


  getLatestExpirations(data) {
    const latestRecords = {};
    let result = [];

    data.forEach(record => {
      const phone = record.telephone;
      const expirationDate = new Date(record.dateexpiration);

      // Si le téléphone n'est pas encore enregistré ou si la date est plus récente, on remplace
      if (!latestRecords[phone] || expirationDate > new Date(latestRecords[phone].dateexpiration)) {
        latestRecords[phone] = record;
      }
    });
    //return Object.values(latestRecords); 

    for (const key in latestRecords) {
      if (latestRecords.hasOwnProperty(key)) {
        result.push(latestRecords[key]);
      }
    }

    return result;
  }

  getAvenantsYiAmYeupp() {
    this.configServer.getAvenantsYiAmYeupp(this.samacaabiyoonwii).then((retourbi) => {
      this.retourClientWS = retourbi;
      console.log("Done");
      this.avenantsYeup = this.retourClientWS.data;
      console.log(this.avenantsYeup);
      this.getAllTransactsByDateInterval();
    });
  }


  getBigChiffres() {
    this.configServer.getBigChiffres(this.samacaabiyoonwii).then((retourbi) => {
      this.retourClientWS = retourbi;
      console.log("Done BIGNUMBERS : ", this.retourClientWS, this.retourClientWS.data, this.localcompliances);
      if (this.retourClientWS.statutreq == 1) {
        this.commissions = this.retourClientWS.data[0].commission;
        for (var i = 0; i < this.localcompliances.length; i++) {
          if (this.localcompliances[i].name == "solde_impaye")
            this.plafondDispo = Number(this.localcompliances[i].valeur) - Number(this.retourClientWS.data[0].montantAVerseDj);
        }
      } else {
        this.commissions = "-";
        this.plafondDispo = undefined;
      }

    });
  }



  parseThisElt(elt) {
    return JSON.parse(elt);
  }


  getAllReprisesByDateInterval() { }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filterPredicate = (data, filter) => {
      return JSON.stringify(data).toLowerCase().includes(filter);
    };
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  filtrerDateEcheance() {
    if (this.datedeb != undefined && this.datefin != undefined) {

      var debut = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');
      var fin = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');

      const currentDate = formatDate(new Date(), "yyyy-MM-dd", 'en-US');
      this.dataSource.filterPredicate = (client, filter: string) => {
        return client.dateexpiration >= debut && client.dateexpiration <= fin;
      };

      this.dataSource.filter = currentDate;
    } else {

      this.dataSource.filterPredicate = (client, filter: string) => {
        return true;
      };

      this.dataSource.filter = "renvoielestous";
    }
  }


  isActif(dateexpiration) {
    const currentDate = formatDate(new Date(), "yyyy-MM-dd", 'en-US');
    return dateexpiration >= currentDate;
  }



  filtrerClientsActifs() {
    const currentDate = formatDate(new Date(), "yyyy-MM-dd", 'en-US');
    this.dataSource.filterPredicate = (client, filter: string) => {
      return client.dateexpiration >= filter;
    };

    this.dataSource.filter = currentDate;
  }



  filtrerClientsInactifs() {
    const currentDate = formatDate(new Date(), "yyyy-MM-dd", 'en-US');
    this.dataSource.filterPredicate = (client, filter: string) => {
      return client.dateexpiration < filter;
    };
    this.dataSource.filter = currentDate;
  }

  filtrerStatutRelance(leStatut) {
    this.dataSource.filterPredicate = (client, filter: string) => {
      return client.statutrelance == filter;
    };
    this.dataSource.filter = leStatut;
    this.theCurrentBlock = leStatut;
  }

  filtrerStatutRelanceRec(leStatut) {
    this.dataSource.filterPredicate = (client, filter: string) => {
      return client.statutrelance == filter;
    };
    this.dataSource.filter = leStatut;
  }



  isOn(leStatut) {
    return this.theCurrentBlock == leStatut;
  }

  getNombreByStatus(leStatut) {
    if (this.dataSource != undefined) {
      return this.dataSource.data
        .filter(client => client.statutrelance == leStatut)
        .reduce((sum, client) => sum + 1, 0);
    } else {
      return 0;
    }
  }


  getTousLesClients() {
    this.tousmesclients = this.getLatestExpirations(this.bruteFromServer);
    this.nbreClients = this.tousmesclients.length;
    this.dataSource = new MatTableDataSource(this.tousmesclients);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  getNbreClientPresqueEchus() {

    const today = new Date();
    today.setDate(today.getDate() + 7);
    const formattedDate = today.toISOString().split('T')[0];

    const kerook = new Date();
    kerook.setDate(kerook.getDate() - 7);
    const kerookformated = kerook.toISOString().split('T')[0];

    if (this.dataSource != undefined) {
      return this.dataSource.data
        .filter(client => client.dateexpiration > kerookformated && client.dateexpiration <= formattedDate)
        .reduce((sum, client) => sum + 1, 0);
    } else {
      return 0;
    }
  }


  getClientPresqueEchus() {
    console.log("There You Go !");

    this.tousmesclients = this.getLatestExpirations(this.bruteFromServer);
    this.tousmesclients = this.getTousPresExpirations(this.tousmesclients);
    this.dataSource = new MatTableDataSource(this.tousmesclients);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getTousPresExpirations(data) {

    const latestRecords = {};
    let result = [];

    const today = new Date();
    today.setDate(today.getDate() + 7);
    const formattedDate = today.toISOString().split('T')[0];

    const kerook = new Date();
    kerook.setDate(kerook.getDate() - 7);
    const kerookformated = kerook.toISOString().split('T')[0];


    console.log("Today+7: ", formattedDate);
    console.log("Today-7: ", kerookformated);

    data.forEach(record => {
      // Si le téléphone n'est pas encore enregistré ou si la date est plus récente, on remplace
      if (record.dateexpiration > kerookformated && record.dateexpiration <= formattedDate) {
        result.push(record);
      }
    });

    return result;
  }


  remotedata(url: string, user: any) {
    return this.httpClient.post<any[]>(url, user, httpOptions).pipe(catchError(this.handleError));
  }

  remoteDataByInterv(url: string, user: any) {
    return this.httpClient.post<any[]>(url, user, httpOptionsII);
  }

  totalCmds(ListCommands) {
    let total: number = 0;
    for (var i = ListCommands.length - 1; i >= 0; i--) {
      total = total + parseInt(ListCommands[i].primeTTC);
    }
    return total;
  }


  totalByDay(ListCommands, dayOrder) {

    let total: number = 0;

    for (var i = ListCommands.length - 1; i >= 0; i--) {
      var theDayI = new Date(ListCommands[i].date);
      var day = theDayI.getDay();
      if (day == dayOrder)
        total = total + parseInt(ListCommands[i].montant);
    }

    console.log(total);
    return total;
  }



  totalCmdsByState(ListCommands, etat) {
    let total: number = 0;
    for (var i = ListCommands.length - 1; i >= 0; i--) {
      if (parseInt(ListCommands[i].etat) == etat)
        total = total + 1;
    }

    console.log(etat.toString() + " - - - " + total.toString());
    return total;
  }



  calculPanierMoyen(commandsList) {
    return Math.trunc(this.totalCmds(commandsList) / commandsList.length);
  }

  calculNbreLivraison(ListCommands) {
    let total: number = 0;
    for (var i = ListCommands.length - 1; i >= 0; i--) {
      if (parseInt(ListCommands[i].etat) == 5)
        total = total + 1;
    }
    return total;
  }

  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }


}


@Pipe({
  name: 'customDate'
})
export class CustomDatePipe extends
  DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return super.transform(value, "EEEE d MMMM y h:mm a");
  }
}

